import { render, staticRenderFns } from "./WhatsNewSection.vue?vue&type=template&id=23f0dff1&scoped=true"
import script from "./WhatsNewSection.vue?vue&type=script&lang=js"
export * from "./WhatsNewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0dff1",
  null
  
)

export default component.exports